import { useState } from 'react';
import { Button } from 'antd';
import { useTranslate } from '@tolgee/react';
import { CommonRefund, DisputeOperate } from 'services/api/return';
import { ButtonProps } from 'antd/es/button';
import DisputeModal from 'components/Refund/DisputeModal';

export interface DisputeProps extends Omit<ButtonProps, 'onClick'>, CommonRefund {
  internalStoreId: string;
  internalTradeId: string;
  onSuccess?: () => void;
}

/** 争议 */
const Dispute = (props: DisputeProps) => {
  const { t } = useTranslate();
  const {
    internalStoreId,
    internalTradeId,
    externalStoreId,
    onSuccess,
    returnSn,
    externalTradeId,
    ...btnProps
  } = props;

  const [visible, setVisible] = useState(false);

  return (
    <>
      <Button size="small" onClick={() => setVisible(true)} {...btnProps}>
        {t('trade.争议')}
      </Button>
      <DisputeModal
        visible={visible}
        setVisible={setVisible}
        internalStoreId={internalStoreId}
        externalStoreId={externalStoreId}
        internalTradeId={internalTradeId}
        externalTradeId={externalTradeId}
        returnSn={returnSn}
        onSuccess={onSuccess}
        disputeOperate={DisputeOperate.争议}
      />
    </>
  );
};

export default Dispute;
